import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'account-created',
    loadComponent: () => import('./two-factor-authentication/account-created/account-created.component'),
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./forgot-password/forgot-password.component'),
  },
  {
    path: 'sign-out',
    loadComponent: () => import('./sign-out/sign-out.component'),
  },
  {
    path: 'sign-in-mobile',
    loadComponent: () => import('./sign-in-mobile/sign-in-mobile.component'),
  },
  {
    path: 'sign-up-portal',
    loadComponent: () => import('./sign-up-portal/sign-up-portal.component'),
  },
  {
    path: 'sign-up-mobile',
    loadComponent: () => import('./sign-up-mobile/sign-up-mobile.component'),
  },
  {
    path: 'sign-in-portal',
    loadComponent: () => import('./sign-in-portal/sign-in-portal.component'),
  },
  {
    path: 'two-factor-authentication',
    loadComponent: () => import('./two-factor-authentication/two-factor-authentication.component'),
  },
  {
    path: 'sign-in-complete',
    loadComponent: () => import('./sign-in-complete/sign-in-complete.component'),
  },
];
